import React from "react";
import styles from '../Proposal.module.css'
import moment from "moment";
import Sharing from "../../Rating/Sharing";

const ProposalItem = ({proposal}) => {
    const date = moment(proposal.created_at).format('DD MMM YYYY')
    return (
        <div className={styles.proposalItem}>
            <img alt='Картинка' src={proposal.media.image}/>
            <div className={styles.textContent}>
                <h2 className={styles.title}>
                    {proposal.name}
                </h2>
                <div style={{display: "flex", justifyContent: 'space-between'}}>
                    <div>
                        {/*<span style={{marginRight: '11px', color: '#73982C', backgroundColor: '#E2EEDD'}}*/}
                        {/*      className="status">Пермь</span>*/}
                        <span className="time">{date}</span>
                    </div>
                    <Sharing isLiked={proposal.is_liked} likes={proposal.likes_count} sharing={proposal.sharings_count} id={proposal.id}/>
                </div>
            </div>

        </div>)
}
export default ProposalItem